import { UPDATE_SIDEBAR_ROLE_INCOTERM_SERVICES } from '../actions/types';
import { isEmpty } from './isEmpty';

/**
 * @memberof module:util
 * @function
 * @name updateSidebarRoleIncoterm
 * @description Set sidebar checkboxes initial states based on all rate cards in the full json.
 *
 * @param {Object} rateJson - Full rate json
 * @param {Function} dispatch - It does dispatch a redux action.
 * @returns {void}
 */
export const updateSidebarRoleIncoterm = (rateJson = {}, dispatch) => {
  const jsonItemsArr =
    (!isEmpty(rateJson) &&
      !isEmpty(rateJson.rates) &&
      Array.isArray(
        rateJson.rates.fcl || rateJson.rates.lcl || rateJson.rates.air
      ) &&
      (rateJson.rates.fcl || rateJson.rates.lcl || rateJson.rates.air)) ||
    [];

  if (Array.isArray(jsonItemsArr) && jsonItemsArr.length === 0) {
    return;
  }

  //these Set only contains Booleans
  let pickupSet = new Set();
  let originSet = new Set();
  let freightSet = new Set();
  let dischargeSet = new Set();
  let ersSet = new Set();
  let deliverySet = new Set();

  // if card is not a variable card then check modes
  jsonItemsArr.map((jsonItem) => {
    pickupSet.add(!!jsonItem.show_variable_rate || !!jsonItem.pickup_checked);
    originSet.add(!!jsonItem.show_variable_rate || !!jsonItem.origin_checked);
    freightSet.add(!!jsonItem.show_variable_rate || !!jsonItem.freight_checked);
    dischargeSet.add(
      !!jsonItem.show_variable_rate || !!jsonItem.discharge_checked
    );
    ersSet.add(!!jsonItem.show_variable_rate || !!jsonItem.ers_checked);
    deliverySet.add(
      !!jsonItem.show_variable_rate || !!jsonItem.delivery_checked
    );
  });

  // const finalObj = {
  //   ...(!Array.from(pickupSet).includes(false) && { pickup: true }),
  //   ...(!Array.from(originSet).includes(false) && { origin: true }),
  //   ...(!Array.from(freightSet).includes(false) && { freight: true }),
  //   ...(!Array.from(dischargeSet).includes(false) && { discharge: true }),
  //   ...(!Array.from(ersSet).includes(false) && { ers: true }),
  //   ...(!Array.from(deliverySet).includes(false) && { delivery: true }),
  // };

  const finalObj = {
    pickup: Array.from(pickupSet).includes(false) ? null : true,
    origin: Array.from(originSet).includes(false) ? null : true,
    freight: Array.from(freightSet).includes(false) ? null : true,
    discharge: Array.from(dischargeSet).includes(false) ? null : true,
    ers: Array.from(ersSet).includes(false) ? null : true,
    delivery: Array.from(deliverySet).includes(false) ? null : true,
  };

  // console.log('here *******:', { finalObj });

  dispatch({
    type: UPDATE_SIDEBAR_ROLE_INCOTERM_SERVICES,
    payload: finalObj,
  });
};


/**
 * @memberof module:util
 * @function
 * @name resetSidebarRoleIncoterm
 * @description It does reset all sidebar checkboxes i.e. set them all unchecked.
 *
 * @param {Function} dispatch - It does dispatch a redux action.
 * @returns {void}
 */
export const resetSidebarRoleIncoterm = (dispatch) => {
  dispatch({
    type: UPDATE_SIDEBAR_ROLE_INCOTERM_SERVICES,
    payload: {
      pickup: null,
      origin: null,
      freight: null,
      discharge: null,
      ers: null,
      delivery: null,
    },
  });
};
